import React, { useRef } from 'react';
import { connect } from "react-redux";
import { Oval } from 'react-loader-spinner';

import { useInventories } from '../hooks/useInventories';

import FileUploadCard from '../../../../Common/DesignSystem/FileUploadCard';
import Button from '../../../../Common/DesignSystem/Button';
import { Heading6, P2, InputLabel } from '../../../../Common/DesignSystem/Text';
import Icon from '../../../../Common/DesignSystem/Icons/Icon';
import colours from '../../../../Common/DesignSystem/Colours';

const ImportOrdersModal = ({ userSession, history, match, location }) => {
  const fileInputRef = useRef();
  const fileDropRef = useRef();

  const { importOrders, importedOrdersFileName, loadingImportOrders } = useInventories({ userSession, history, match, location });

  const showImportInput = !importedOrdersFileName && !loadingImportOrders;

  const closeModal = () => {
    window.history.back();
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minWidth: '50vw', height: '500px', maxHeight: '90vh', padding: '24px', backgroundColor: '#FFF' }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '16px', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
        <div className="overlay_header_close" onClick={closeModal} style={{ position: 'absolute', right: '0', top: '0', padding: 0 }}>
          &times;
        </div>
        {showImportInput && (
          <>
            <Heading6>Upload Orders Data</Heading6>
            <P2>Upload a CSV file to import orders data to your vehicle list</P2>
          </>
        )}
      </div>

      {showImportInput ? (
        <div style={{ flex: 1 }}>
          <InputLabel style={{ padding: '4px 16px' }}>
            Orders Data
            <div className="ds-input-required">*</div>
          </InputLabel>
          <FileUploadCard
            accept=".csv, .xls, .xlsx"
            uploadText="Add File or Drop File Here"
            inputRef={fileInputRef}
            dropRef={fileDropRef}
            replaceClick={() => fileInputRef.current.click()}
            handleUpload={importOrders}
          />
        </div>
      ) : (
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '8px', alignItems: 'center', justifyContent: 'center' }}>
          {loadingImportOrders ? (
            <>
              <Oval height={128} width={128} strokeWidth={7} color={colours.primary.blue} secondaryColor={colours.functional.hover_primaryblue} />
              <Heading6>Checking Imported File</Heading6>
              <P2>Please wait a few seconds while we’re validating your data</P2>
            </>
          ) : (
            <>
              <Icon name="Check" size={128} style={{ backgroundColor: colours.accent.validate_green, borderRadius: '100%', color: '#FFF'}} />
              <Heading6>Import Complete</Heading6>
              <P2>Your orders data is now available on the Orders List</P2>
            </>
          )}
        </div>
      )}

      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
        <Button secondary large label={importedOrdersFileName ? "Close" : "Cancel"} onClick={closeModal} style={{ width: '172px' }} />
      </div>
    </div>
  )
}

const mapStateToProps = store => ({
  userSession: store.userSession,
  data: store.data,
  settings: store.settings,
  stakeholder: store.stakeholder
})

export default connect(mapStateToProps)(ImportOrdersModal)